"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DeletItemSwipeButton = require("./DeletItemSwipeButton");
Object.keys(_DeletItemSwipeButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeletItemSwipeButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DeletItemSwipeButton[key];
    }
  });
});